import React from "react";
import classNames from "classnames";
import "@/Scss/Components/radio.scss";

export default function Radio(props) {
    const {
        name,
        value,
        checked,
        isBorder,
        onChange = () => {
        },
        label = '',
        textPosition = 'right',
        disabled = false,
    } = props;

    const radioContainer = classNames('radioContainer', props.className, {
        'right': textPosition === 'right',
        'left': textPosition === 'left',
        'disabled': disabled,
        'border': isBorder,
    });

    return (
        <label className={radioContainer}>
            <span className={`radioContainer__radio`}>
                <input name={name}
                       value={value}
                       type={`radio`}
                       className={`radioInput`}
                       onChange={(e) => onChange(e)}
                       disabled={disabled}
                       checked={checked}
                />
                <span className={`parentCircle${checked ? ' active' : ''}`}>
                    <span className={`childCircle${checked ? ' active' : ''}`}></span>
                </span>
            </span>
            {label !== '' && (
                <span className={`radioContainer__label`}>{label}</span>
            )}
        </label>
    );
}
